/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import PropTypes from 'prop-types';
import React from 'react';

import { ProvisionedCard } from '../../homepage-card';
import SuccessCommunityItem from './item';
import SuccessCommunitySearch from './search';

function SuccessCommunityCard({ className, heading, localizations }) {
  const searchBar = (
    <SuccessCommunitySearch
      assistiveText={{ label: localizations['homepage.cards.success_community.search.assistive_text'] }}
      placeholder={localizations['homepage.cards.success_community.search.placeholder']}
    />
  );

  return (
    <ProvisionedCard className={className} heading={heading} footer=" " subHeader={searchBar}>
      <ul className="slds-has-dividers--bottom-space">
        <SuccessCommunityItem
          body={localizations['homepage.cards.success_community_item.browse_official_documentaion.body']}
          buttonLabel={localizations['homepage.cards.success_community_item.browse_official_documentaion.button_label']}
          title={localizations['homepage.cards.success_community_item.browse_official_documentaion.title']}
          url="https://help.salesforce.com"
        />
        <SuccessCommunityItem
          body={localizations['homepage.cards.success_community_item.post_your_questions.body']}
          buttonLabel={localizations['homepage.cards.success_community_item.post_your_questions.button_label']}
          title={localizations['homepage.cards.success_community_item.post_your_questions.title']}
          url="https://success.salesforce.com/answers?feedtype=RECENT&criteria=BESTANSWERS"
        />
      </ul>
    </ProvisionedCard>
  );
}

SuccessCommunityCard.displayName = 'Success Community Card';

SuccessCommunityCard.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string,
  localizations: PropTypes.object,
};

SuccessCommunityCard.defaultProps = {
  heading: '',
};

export default SuccessCommunityCard;
